import { render, staticRenderFns } from "./SolanJournalsTable.vue?vue&type=template&id=51fc06e0&scoped=true&"
import script from "./SolanJournalsTable.vue?vue&type=script&lang=ts&"
export * from "./SolanJournalsTable.vue?vue&type=script&lang=ts&"
import style0 from "./SolanJournalsTable.vue?vue&type=style&index=0&id=51fc06e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc06e0",
  null
  
)

export default component.exports